/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_Col_CrmInputs */

const cs_portals_sync_col_crm = /** @type {(inputs: Portals_Sync_Col_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM očekává`)
};

const en_portals_sync_col_crm = /** @type {(inputs: Portals_Sync_Col_CrmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM expects`)
};

/**
* | output |
* | --- |
* | "CRM expects" |
*
* @param {Portals_Sync_Col_CrmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_col_crm = /** @type {((inputs?: Portals_Sync_Col_CrmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Col_CrmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_col_crm(inputs)
	return cs_portals_sync_col_crm(inputs)
});